import gql from 'graphql-tag';

export default gql`
  mutation removeByIdCourseMutation($_id: MongoID!) {
    removeByIdCourseMutation(_id: $_id) {
      recordId
      message
      title
    }
  }
`;
